const project = require('../../project.config')

const __DEV__ = project.env === 'development'
const __TEST__ = project.env === 'stage'
const __PROD__ = project.env === 'production'

let secConfig
let appConfig

if (__DEV__) {
  secConfig = require('./security.dev.js')
  appConfig = require('./app.dev.js')
} else if (__TEST__) {
  secConfig = require('./security.test.js')
  appConfig = require('./app.test.js')
} else if (__PROD__) {
  secConfig = require('./security.prod.js')
  appConfig = require('./app.prod.js')
} else {
  throw "ERROR NO ENVIROMENT"
}

export const securityConfig = secConfig;
export const applicationConfig = appConfig;

export default {
  config: applicationConfig,
  securityConfig: securityConfig
}


// WEBPACK FOOTER //
// ./src/config/config.js